import React from "react";
import onerraLogo from "../../assets/onerra-logo-icon.png";

/**
 * The Onerra mark — request 1108: the company's own logo image (green rounded square, white ring and dot), resized from
 * apps/web/brand/onerra-logo-master.png. Used on the login page footer and the sidebar credit.
 */
export function OnerraIcon({ className }: { className?: string }) {
  return <img src={onerraLogo} alt="Onerra" className={className} draggable={false} />;
}
